import { Phone, Mail, MapPin, MessageCircle } from "lucide-react";
import { DOCTOR, CLINICS } from "@/lib/data";

const waLink = (p) => `https://wa.me/91${p.replace(/\D/g, "").slice(-10)}?text=${encodeURIComponent("Hello Dr. Chandrani Jha, I'd like to enquire about an appointment.")}`;

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-forest text-linen pt-20 pb-10 mt-10">
      <div className="container-page grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <h3 className="font-serif text-3xl md:text-4xl leading-tight">{DOCTOR.name}</h3>
          <p className="mt-2 text-linen/60 text-sm tracking-[0.2em] uppercase">{DOCTOR.title}</p>
          <p className="mt-6 text-linen/75 max-w-md leading-relaxed">{DOCTOR.tagline}</p>
          <p className="mt-4 text-linen/60 text-sm">{DOCTOR.qualifications}</p>
        </div>

        <div className="md:col-span-3">
          <p className="label-eyebrow text-linen/60">Reach Us</p>
          <ul className="mt-5 space-y-3 text-linen/80">
            {DOCTOR.phones.map((p) => (
              <li key={p} className="flex items-center gap-3">
                <a href={`tel:${p.replace(/\s/g, "")}`} data-testid={`footer-call-${p.replace(/\s/g, "")}`} className="inline-flex items-center gap-2 hover:text-terracotta transition-colors">
                  <Phone className="w-4 h-4" strokeWidth={1.5} /> {p}
                </a>
                <a
                  href={waLink(p)}
                  target="_blank"
                  rel="noreferrer"
                  data-testid={`footer-wa-${p.replace(/\s/g, "")}`}
                  aria-label={`WhatsApp ${p}`}
                  className="inline-flex items-center justify-center w-7 h-7 rounded-full bg-[#25D366]/15 text-[#25D366] hover:bg-[#25D366] hover:text-white transition-colors"
                  title="Chat on WhatsApp"
                >
                  <MessageCircle className="w-3.5 h-3.5" strokeWidth={1.75} />
                </a>
              </li>
            ))}
            <li>
              <a href={`mailto:${DOCTOR.email}`} className="inline-flex items-center gap-3 hover:text-terracotta transition-colors break-all">
                <Mail className="w-4 h-4" strokeWidth={1.5} /> {DOCTOR.email}
              </a>
            </li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <p className="label-eyebrow text-linen/60">Clinics in Birpara</p>
          <ul className="mt-5 space-y-4 text-linen/80">
            {CLINICS.map((c) => (
              <li key={c.id} className="leading-relaxed">
                <div className="font-medium text-linen">{c.name}</div>
                <a href={c.mapsLink} target="_blank" rel="noreferrer" className="inline-flex items-start gap-2 text-sm text-linen/70 hover:text-terracotta transition-colors">
                  <MapPin className="w-4 h-4 mt-0.5 shrink-0" strokeWidth={1.5} /> {c.address}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="container-page mt-16 pt-8 border-t border-linen/10 flex flex-col md:flex-row items-center justify-between gap-4 text-linen/50 text-sm">
        <p>© {new Date().getFullYear()} {DOCTOR.name}. All rights reserved.</p>
        <p className="text-xs tracking-[0.2em] uppercase">drchandranijha.com · Birpara · Alipurduar</p>
      </div>
    </footer>
  );
}
